import { ReportNames } from 'features/reports/campaigns/types';

export const SUPPORTED_NATIVE_DASHBOARD_REPORTS = [
  ReportNames.CROSS_CHANNEL,
  ReportNames.PAID_SOCIAL,
  ReportNames.PAID_SEARCH,
  ReportNames.PROGRAMMATIC_FOR_TRADE_DESK,
] as const;

export type SupportedNativeDashboardReportName =
  (typeof SUPPORTED_NATIVE_DASHBOARD_REPORTS)[number];
